<h4 class="header">{{summaryHeader}}</h4>
<div class="summary-section">
  <div class="summary-header">
    <div class="summary-header__item"><span class="bold">LOAD ID: </span><span>{{currentDataLoadId}}</span></div>
    <div class="summary-header__item"><span class="bold">PROJECT NAME: </span><span>{{dataLoadState.projectName}}</span>
    </div>
    <div class="summary-header__item"><span class="bold">PRODUCT TYPE: </span><span>{{dataLoadState.projectType}}</span>
    </div>
  </div>
  <div class="summary-body"
    *ngIf="getIsVendorMatchingRequired && getIsVendorMatchingCompleted && !isValidationComplete; else elseIfBlock">
    <div class="summary-body__content">
      <div class="summary-body__type">Vendor Matching Status</div>
      <div class="summary-body__details">{{ getVendorMatchingStatus }}</div>
    </div>
  </div>
  <ng-template #elseIfBlock>
    <div class="summary-body">
      <div class="summary-body__header">
        <div class="summary-body__type bold">TYPE</div>
        <div class="summary-body__details bold">DETAILS</div>
      </div>
      <div class="summary-body__content" [class.odd]="odd"
        *ngFor="let item of summaryReport; let odd = odd; trackBy: trackByIndex">
        <div class="summary-body__data">
          <div class="summary-body__type" [ngClass]="{ 'flex-row': isChase(item) || isAddress(item) || isError(item) }">
            <div *ngIf="isChase(item)" (click)="expandedChase = !expandedChase" class="iconHere">
              <app-icon iconStyle="fal" iconType="fa" [iconName]="getIconName(item)">
              </app-icon>
            </div>
            <div *ngIf="isAddress(item)" (click)="expandedAddress = !expandedAddress"
              class="iconHere">
              <app-icon iconStyle="fal" iconType="fa" [iconName]="getIconName(item)">
              </app-icon>
            </div>
            <div (click)="toggleSection(item.key)" class="iconHere"
              *ngIf="showIcon(item)">
              <app-icon iconStyle="fal" iconType="fa" [iconName]="getIconName(item)">
              </app-icon>
            </div>{{item.key}}
          </div>
          <div [ngClass]="getValidationMessageClass(item.value)" class="summary-body__details">
            {{item.value}}
          </div>
        </div>
        <div class="toggleData" *ngIf="showErrorToggle(item)">
          <div class="showCount" *ngFor="let item of errorSummaryReport; trackBy: trackByIndex">
            <p title="{{item.messageGroupHeader}}">{{item.messageGroupHeader}}</p> <span>{{item.messageCount}}</span>
          </div>
        </div>
        <div class="toggleData" *ngIf="showWarningToggle(item)">
          <div class="showCount" *ngFor="let item of warningSummaryReport; trackBy: trackByIndex">
            <p title="{{item.messageGroupHeader}}">{{item.messageGroupHeader}}</p> <span> {{item.messageCount}}
            </span>
          </div>
        </div>

        <div class="toggleChaseData" *ngIf="showChaseToggle(item)">
          <div class="showChaseCount" [class.odd]="odd"
            *ngFor="let chase of chaseSummaryReport; let odd = odd, let last = last, trackBy: trackByIndex">
            <p>{{ chase.key }}</p>
            <span>{{ chase.value }}</span>
          </div>
        </div>

        <div class="toggleChaseData" *ngIf="showAddressToggle(item)">
          <div class="showChaseCount" [class.odd]="odd"
            *ngFor="let address of addressSummaryReport; let odd = odd, let last = last, trackBy: trackByIndex">
            <p>{{ address.key }}</p>
            <span>{{ address.value }}</span>
          </div>
        </div>
      </div>


    </div>
  </ng-template>

  <div
    *ngIf="isLoadProcess && isValidationComplete && (getIsVendorMatchingCompleted || isDataLoadWithIssues); else elseIfForLoadProcess"
    class="summary-footer">
    <div *ngIf="isDataLoadNoWarningsEnabled" class="text-right">
      <app-button classes="danger" class="summary-footer__button" text="UPLOAD FILES" (onClick)="startDataLoad()">
      </app-button>
    </div>
    <div *ngIf="isDataLoadWithWarningsEnabled" class="text-center footer-button">
      <app-button classes="secondary" class="summary-footer__button" text="DOWNLOAD VALIDATION SUMMARY"
        (onClick)="getErrorReport()" [disabled]="disableValidationSummaryBtn">
      </app-button>
      <app-button *ngIf="getIsVendorMatchingCompleted" classes="danger" class="summary-footer__button"
        text="UPLOAD FILES WITH WARNINGS" (onClick)="startDataLoad()">
      </app-button>
      <app-button *ngIf="!getIsVendorMatchingCompleted" classes="danger" class="summary-footer__button"
        text="Vendor Matching" (onClick)="startVendorMatching()">
      </app-button>
    </div>
    <div *ngIf="isPartialDataLoadEnabled" class="text-center footer-button">
      <app-button classes="secondary" class="summary-footer__button" text="DOWNLOAD VALIDATION SUMMARY"
        (onClick)="getErrorReport()" [disabled]="disableValidationSummaryBtn">
      </app-button>
      <app-button *ngIf="getIsVendorMatchingCompleted" classes="danger" class="summary-footer__button"
        [text]="loadChasesText" (onClick)="startDataLoad()"></app-button>
      <app-button *ngIf="!getIsVendorMatchingCompleted" classes="danger" class="summary-footer__button"
        text="Vendor Matching" (onClick)="startVendorMatching()">
      </app-button>
    </div>
    <div *ngIf="isDataLoadDisabled" class="text-center">
      <div class="summary-footer__error-message">Please fix critical error(s) to continue.</div>
      <app-button classes="secondary" class="summary-footer__button" text="DOWNLOAD VALIDATION SUMMARY"
        (onClick)="getErrorReport()" [disabled]="disableValidationSummaryBtn">
      </app-button>
    </div>
  </div>
  <ng-template #elseIfForLoadProcess>
    <div *ngIf="isLoadProcess" class="text-center vendorMatching  footer-button">
      <app-button *ngIf="getVendorMatchingStatus === 'Failed'" classes="secondary"
        class="upload__documentUpload--button" text="Process Without Vendor Matching"
        (onClick)="startDataValidation()"></app-button>
      <app-button *ngIf="!getIsVendorMatchingCompleted" class="vendorMatching--button" text="Vendor Matching"
        (onClick)="startVendorMatching()"></app-button>
      <app-button *ngIf="getVendorMatchingStatus === 'Completed'" class="vendorMatching--button" text="Validate"
        (onClick)="startDataValidation()"></app-button>
    </div>
  </ng-template>
</div>
<div *ngIf="isUploadSuccess && isDataLoadWithIssues" class="summary-footer">
  <div class="text-left">
    <app-button classes="secondary" class="summary-footer__button" text="DOWNLOAD VALIDATION SUMMARY"
      (onClick)="getErrorReport()" [disabled]="disableValidationSummaryBtn">
    </app-button>
  </div>
</div>

<app-result-modal class="processing-modal" [(visible)]="isProcessingVisible" header="{{processHeaderText}}"
  [allowClose]="true">
  <div class="processing-modal__icon-spinner">
    <app-icon iconName="spinner" spin=true></app-icon>
  </div>
  <div class="processing-modal__message">This might take a few minutes</div>
</app-result-modal>